import { ComponentPortal, PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Injector, Input, NgModule, OnInit, Output } from '@angular/core';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Utilities } from '@app/common/utilities';
import { PortalInjectorFactory } from '@app/injectors/portal.injector';
import { PersonExtended } from '@app/models/person-extended';
import { LinkModule } from '@app/directives/link.directive';
import { SafeModule } from '@app/pipes/safe.pipe';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { UserService } from '@app/services/user.service';
import { Environment } from '@environments/interface.environment';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-people-card',
  templateUrl: './people-card.component.html',
  styleUrls: ['./people-card.component.scss']
})
export class PeopleCardComponent implements OnInit {

  mobilePhonePortal: ComponentPortal<any>;

  @Input() person: PersonExtended;
  @Input() newtab = false;
  @Input() expanded = true;
  @Input() size: 'small' | 'regular' = 'regular';
  @Input() useTeamsChat = true;
  @Output() clicked = new EventEmitter<boolean>();
  showDepartment: boolean;
  showLocation: boolean;
  showOfficePhone: boolean;
  showOrgChart: boolean;
  photoUrl$: Observable<string>;
  enableProfileCardView: boolean;
  userUpn: string;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
              private featureStoreSettingsService: FeatureSettingsStoreService,
              private userService: UserService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private injector: Injector) { }

  getPreferredNameLetters = (person: PersonExtended): string => Utilities.generateInitials(person.displayName);

  /** Delve URL for user */
  getDelveUrl(person: PersonExtended): string {
    if (person.id) {
      return 'https://delve.office.com/?u=' + person.id;
    } else {
      return person.fallbackUrl;
    }
  }

  whenPersonClicked(event: Event, navigate = false) {
    this.clicked.emit(navigate);

    // HACK: Because of this bug https://github.com/angular/angular/issues/13523 we have to do it this way.
    if (navigate) {
      if (this.activatedRoute.parent.outlet === 'modal') {
        this.router.navigate(['', { outlets: { modal: null } }])
          .then(() => {
            return this.router.navigate([`/user/detail/`, this.userUpn]);
          });
      } else {
        this.router.navigate([`/user/detail/`, this.userUpn]);
      }
    }
  }

  isExternalUser(person: PersonExtended): boolean {
    if (person.userPrincipalName) {
      return person.userPrincipalName.includes('#EXT#');
    }
    return false;
  }

  ngOnInit() {
    this.showDepartment = this.featureStoreSettingsService.state.myColleaguesShowDepartment;
    this.showLocation = this.featureStoreSettingsService.state.myColleaguesShowLocation;
    this.showOfficePhone = this.featureStoreSettingsService.state.myColleaguesShowOfficePhone;
    this.showOrgChart = this.featureStoreSettingsService.state.myColleaguesShowOrgChart;
    this.enableProfileCardView = this.featureStoreSettingsService.state.enableProfileCardView;
    this.photoUrl$ = this.userService.getUserPhotoByUpn(this.person.userPrincipalName);

    const re = /\./gi;
    this.userUpn = this.person.userPrincipalName.replace(re, '/');

    if (this.environment.customComponents && this.environment.customComponents.has('mobilePhonePortal')) {
      const portalInjector = PortalInjectorFactory.create(this.injector, { person: this.person });
      this.mobilePhonePortal = new ComponentPortal(this.environment.customComponents.get('mobilePhonePortal'), null, portalInjector);
    }
  }

}
@NgModule({
  declarations: [PeopleCardComponent],
  exports: [PeopleCardComponent],
  imports: [
    CommonModule,
    LinkModule,
    SafeModule,
    PortalModule,
    RouterModule
  ],
})
export class PeopleCardModule { }
